import React from "react";
import ListResponsive from "../../other/ListResponsive";
import {
  Grid,
  Link,
  MenuItem,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";

export default function GameSystemPickerList(props) {
  const { items, handleChange, request, valueType } = props;
  const theme = useTheme();

  return (
    <>
      <ListResponsive
        originalList={items}
        doSearch
        searchProps={{
          label: `Search Game Systems`,
          performSearch: (originalList, searchText) => {
            if (!searchText || searchText === "") {
              return originalList;
            } else {
              const filteredList = originalList.filter(function (el) {
                let found = false;
                if (el?.isHeader) {
                  el?.gameSystems?.forEach((gs) => {
                    if (gs?.name?.toLowerCase().includes(searchText))
                      found = true;

                    if (gs?.manufacturer?.toLowerCase().includes(searchText))
                      found = true;
                  });

                  return found;
                }

                if (el?.name?.toLowerCase().includes(searchText)) return true;

                if (el?.manufacturer?.toLowerCase().includes(searchText))
                  return true;
                return false;
              });
              return filteredList;
            }
          },
        }}
        rowProps={{
          mapFunction: (row, index) => {
            if (row?.isHeader) {
              return (
                <Grid
                  item
                  xs={12}
                  key={`${index}-${row?.manufacturer}`}
                  sx={{
                    backgroundColor: "background.primary",
                    p: 1,
                    pl: 2,
                  }}
                >
                  <Typography variant="h4" value="">
                    {row?.manufacturer}
                  </Typography>
                </Grid>
              );
            }

            const r = (
              <Grid
                item
                xs={12}
                key={valueType === "id" ? row.id : row.code}
                sx={{
                  borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                  boxShadow: 1,
                  backgroundColor: "background.secondary",
                }}
              >
                <MenuItem
                  value={valueType === "id" ? row.id : row.code}
                  fullWidth
                  onClick={(e) => {
                    handleChange(e);
                  }}
                  disabled={row?.disabled}
                >
                  {row?.name}
                </MenuItem>
              </Grid>
            );

            if (Boolean(row?.hover)) {
              return (
                <Tooltip title={<React.Fragment>{row?.hover}</React.Fragment>}>
                  {r}
                </Tooltip>
              );
            }

            return r;
          },
        }}
        sx={{
          border: `1px solid ${theme?.palette?.divider}`,
          borderRadius: "8px",
          overflow: "hidden",
        }}
      />
      {/* TODO: Need to update link with href to a page to request game systems */}
      {request && (
        <Typography variant="body1" sx={{ p: 2, pl: 1 }}>
          Can't find what you're looking for?{" "}
          <Link href="/support" target="_blank">
            Submit a game system request
          </Link>
        </Typography>
      )}
    </>
  );
}
